import { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useGlobalContext } from "../data/GlobalContext"
import LoginGlobal from "../data/LoginGlobal"
import LoginToPlay from "../data/LoginToPlay"

export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

function Sportsbookpage() {
  const { tokenUrl, launchUrl, username } = useGlobalContext()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [login, setLogin] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  const livegamesSelection = [
    // {
    //   id: 1,
    //   image: "/images/sportsbetting-ap.webp",
    //   text: "Sports",
    //   subtxt: "Leading in Asia",
    //   gameID: "62001",
    // },
    // {
    //   id: 2,
    //   image: "/images/sportsbetting-esports.webp",
    //   text: "Esport",
    //   subtxt: "Leading in Asia",
    //   gameID: "62021",
    // },
    {
      id: 3,
      image: "/images/sportsbetting-asc.webp",
      text: "ASC",
      subtxt: "No.1 in Asia",
      gameID: "33001",
    },
    {
      id: 4,
      image: "/images/saba-sports.webp",
      text: "Sports",
      subtxt: "No.1 in Asia",
      gameID: "102001",
    },
  ]

  const launchGameForSelection = async (data) => {
    if (!username) {
      setLogin(true)
      return
    }

    const newWindow = window.open(
      "",
      "gameWindow",
      "width=1024,height=768,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes"
    )
    if (!newWindow) {
      alert("Popup blocked. Please allow popups and try again.")
      return
    }

    // Determine mobile vs desktop
    const isMobile = window.innerWidth <= 768
    const mParam = isMobile ? "1" : "0"

    try {
      // Fetch session token with mobile flag
      const requestUrl = `${tokenUrl}?u=${encodeURIComponent(username)}&g=${
        data.gameID
      }&t=0&m=${mParam}`
      const response = await fetch(requestUrl)
      if (!response.ok) {
        newWindow.close()
        alert("Failed to fetch game token. Please try again.")
        return
      }
      const jsonData = await response.json()
      const sessionToken = jsonData?.token
      if (!sessionToken) {
        newWindow.close()
        alert("Token not received. Please try again.")
        return
      }
      const lang = "en"

      // Launch with mobile flag
      const launchURL = `${launchUrl}?s=${sessionToken}&l=${lang}&m=${mParam}`
      newWindow.location.href = launchURL
    } catch (error) {
      newWindow.close()
      console.error("Error launching game:", error)
      alert("An unexpected error occurred. Please try again.")
    }
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sportsbook - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Bet on live sports at FGH with real-time odds and fast results. Easy GCash/Maya payments for Filipino players 21 and above."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>

      {login && <LoginToPlay onClose={() => setLogin(false)} />}

      <section className="main-body-content all-page-main-container-min-height main-container-global-adjusted-padding">
        <div className="fgh-live-casino-page-main">
          <h1 className="fgh-h1-style normal-margin-bottom">
            Bet on your Favorite Team
          </h1>
          <label className="fgh-normal-label-style standard-margin-bottom">
            (AP Sports, Asian Sportbetting Club)
          </label>
          <div className="fgh-live-casino-page-selection fgh-sportsbook-selection">
            {livegamesSelection.map((data) => (
              <div key={data.id} className="live-casino-page-selection-items">
                <img src={data.image} alt={data.text} />
                <div>
                  <label>{data.text}</label>
                  {data.gameID ? (
                    <button onClick={() => launchGameForSelection(data)}>
                      View Lobby
                    </button>
                  ) : (
                    <p>Game not available.</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="fgh-section-margin fgh-section-articles">
          <div className="fgh-main-page-content">
            <h2 className="fgh-h2-style standard-margin-bottom">
              FGH – Best Casino Site, Just for You
            </h2>
            <p className="fgh-paragraph-standard-style">
              Get ready to spin, win, and have a blast! At FGH, we bring you a
              thrilling collection of online slots designed to keep the
              excitement rolling. Whether you're here for big wins, fun themes,
              or just some good old-fashioned luck, we’ve got something for
              everyone. No complicated rules, just pure entertainment at your
              fingertips!
            </p>
            <p className="fgh-paragraph-standard-style">
              So, why wait? Dive into the action, explore our wide range of
              slots, and let the reels do the talking. Who knows? Your next spin
              could be the lucky one!
            </p>
            <LoginGlobal label="Play Now" onlyBtn={true} />
          </div>
        </div>
      </section>
    </>
  )
}

export default Sportsbookpage
